export const Getters = {
    snapshotDateFilter: state => {
      return state.snapshotDateFilter;
    },
    getToken: state => {
      return state.token;
    },
    getSearchFilterObj: state => {
      return state.searchFilterObj;
    },
    getSortBy: state => {
      return state.sortBy;
    },
    getSortDesc: state => {
      return state.sortDesc;
    },
    getAllEstimates: state => {
        return state.items;
    },
    getTimestamp: state => {
        return state.timestamp;
    },
    getEstimatesPerPage: (state) => {
        return state.estimatesPerPage;
    },
    getEstimatesAllCurrentPage: (state) => {
        return state.estimatesAllCurrentPage;
    },
    // Check if estimates exist without depending on the full items array reference
    hasEstimates: (state) => {
        return state.items.length > 0;
    },
}
